import { useEffect } from "react";

import useTableData from "../../../../state/table/UseTableData";

const useTableWrapper = (data, rowIdKey, defaultSortKey, defaultSortType, defaultSortDirection, expandAll, selectAll) => {
  const { tableState, initializeTableState, onUpdateTableData } = useTableData();

  useEffect(() => {
    if (tableState.isInitialized === true) {
      onUpdateTableData(data);
    } else {
      initializeTableState(data, rowIdKey, defaultSortKey, defaultSortType, defaultSortDirection, expandAll, selectAll);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    tableState
  };
};

export default useTableWrapper;
